import { render, staticRenderFns } from "./MultipleAllergensMapTpl.vue?vue&type=template&id=bbb94598&"
import script from "./MultipleAllergensMapTpl.vue?vue&type=script&lang=js&"
export * from "./MultipleAllergensMapTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports